module.exports = __webpack_public_path__ + "img/cpany4.34341ce9.png";